import React, {useEffect, useState} from 'react';
import { Input, Col, Row, FormGroup, Label} from 'reactstrap';
import { Form, Field } from 'react-final-form';
import axios from 'axios'
import {labelizeNamedData} from '@/shared/helpers'
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage"
import {getLeaderboardTypes} from '@/services/program/getLeaderboardTypes'
import renderSelectField from '@/shared/components/form/Select'
import TemplateButton from "@/shared/components/TemplateButton"
import DatePicker from "react-datepicker";

const AddLeaderboardForm = ({
    organization,
    program,
    toggle,
    setLeaderboard,
    }) => {
    const dispatch = useDispatch()

    const [leaderboardTypes, setLeaderboardTypes] = useState([]);
    const [loading, setLoading] = useState(true);

    const onSubmit = (values) => {
        let formData = {};

        formData["leaderboard_type_id"] = values.leaderboard_type_id.value;
        formData["name"] = values.name;
        formData["start_date"] = values.start_date
            ? values.start_date.toISOString().split('T')[0]
            : null;

        formData["end_date"] = values.end_date
            ? values.end_date.toISOString().split('T')[0]
            : null;

        setLoading(true)
        axios
          .post(`/organization/${organization.id}/program/${program.id}/leaderboard`, formData)
          .then((res) => {
            //   console.log(res)
            if (res.status == 200) {
                // alert(window.location.href);
                // window.location.reload()
                dispatch(sendFlashMessage('Leaderboard added successfully!', 'alert-success', 'top'))
                toggle(null, true);
                setLeaderboard(res.data?.leaderboard)
                toggle("EditLeaderboard");
                setLoading(false)
            }
          })
          .catch((err) => {
            //console.log(error.response.data);
            dispatch(sendFlashMessage(<ApiErrorMessage errors={err.message} />, 'alert-danger', 'top'))
            setLoading(false)
          });
    };

    useEffect(() => {
        if( organization && program )   {
            let mounted = true;
            setLoading(true)
            getLeaderboardTypes(organization.id, program.id)
                .then(items => {
                if(mounted) {
                    setLeaderboardTypes(labelizeNamedData(items))
                    setLoading(false)
                }
                })
            return () => mounted = false;
        }
    }, [organization, program])  
    
    let props = {
        organization,
        program,
        }
    return(
        <Form
            onSubmit={onSubmit}
            validate={validate}
        >
            {({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="form d-flex flex-column justify-content-evenly" onSubmit={handleSubmit}>
                <Row>
                    <Col md="4">
                        <Label>Leaderboard Name</Label>
                    </Col>
                    <Col md="8">
                        <Field name="name">
                        {({ input, meta }) => (
                            <FormGroup>
                                <Input
                                placeholder="Leaderboard Name"
                                type="text"
                                {...input}
                                />
                                {meta.touched && meta.error && <span className="text-danger">
                                    {meta.error}
                                </span>}
                            </FormGroup>
                        )}
                        </Field>
                    </Col>
                </Row>
                <Row>
                    <Col md="4">
                        <Label>Select leaderboard type</Label>
                    </Col>
                    <Col md="8">
                        <Field 
                                name="leaderboard_type_id"
                                className="react-select"
                                options={leaderboardTypes}
                                placeholder={'Select Event Type'}
                                component={renderSelectField}
                                // parse={value => {
                                //     return value;
                                // }}
                        />
                    </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col md="4">
                            <Label>Start Date</Label>
                        </Col>
                        <Col md="8">
                            <Field name="start_date">
                                {({ input, meta }) => (
                                    <FormGroup>
                                        <DatePicker
                                            selected={input.value ? new Date(input.value) : null}
                                            onChange={date => input.onChange(date)}
                                            onBlur={input.onBlur}
                                            minDate={new Date()}
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control"
                                            placeholderText="Select start date"
                                            popperClassName="manager-program-settings-modal__datepicker-popper"
                                            popperProps={{ strategy: "fixed" }}
                                        />
                                        {meta.touched && meta.error && (
                                            <span className="text-danger">{meta.error}</span>
                                        )}
                                    </FormGroup>
                                )}
                            </Field>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <Label>End Date</Label>
                        </Col>
                        <Col md="8">
                            <Field name="end_date">
                                {({ input, meta }) => (
                                    <FormGroup>
                                        <DatePicker
                                            selected={input.value ? new Date(input.value) : null}
                                            onChange={date => input.onChange(date)}
                                            onBlur={input.onBlur}
                                            minDate={new Date()}
                                            dateFormat="yyyy-MM-dd"
                                            className="form-control"
                                            placeholderText="Select end date"
                                            popperClassName="manager-program-settings-modal__datepicker-popper"
                                            popperProps={{ strategy: "fixed" }}
                                        />

                                        {meta.touched && meta.error && (
                                            <span className="text-danger">{meta.error}</span>
                                        )}
                                    </FormGroup>
                                )}
                            </Field>
                        </Col>
                    </Row>

                <div className='d-flex justify-content-end'>
                    <TemplateButton disabled={loading} type='submit' text='Save' />
                </div>
            </form>
            )}
        </Form>
    )
}

const validate = values => {
    let errors = {}
    if( !values.name )   {
        errors.name = 'Please enter leaderboard name'
    }
    if( !values.leaderboard_type_id )   {
        errors.leaderboard_type_id = 'Please select leaderboard type'
    }
    if (values.start_date && values.end_date) {
        if (values.end_date < values.start_date) {
            errors.end_date = 'End date must be after start date'
        }
    }
    return errors
}

export default AddLeaderboardForm;
